/**
 * Module dependencies.
 */

import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PieChartOutlined } from '@ant-design/icons';
import { Outlet } from 'react-router-dom';
import { Dashboard } from './dashboard';
import { appRoutes } from 'app/routes';
import { compileMenu } from 'app/core/utils/menu';
import { TfiSupport } from 'react-icons/tfi';

/**
 * Export `SkinSupport` component.
 */

export function SkinSupport(): JSX.Element {
  const [translate] = useTranslation();
  const items = useMemo(
    () =>
      compileMenu([
        {
          key: '1',
          pathname: appRoutes.dashboard.support.base,
          icon: <PieChartOutlined />,
          label: translate('support.menu.overview')
        },
        {
          key: '2',
          pathname: appRoutes.dashboard.support.openTickets,
          icon: <TfiSupport />,
          label: translate('support.menu.openTickets')
        }
      ]),
    [translate]
  );

  return (
    <Dashboard menu={items}>
      <Outlet />
    </Dashboard>
  );
}
